import React from 'react';
import {withI18n} from "@lingui/react";
import {connect} from 'react-redux';
import {Select} from "../../DataEntry";

const { Option } = Select;

/**
 * Options
 * N/A
 * isPublic: boolean defaults as undefined. If true, will use public list api
 **/
function CountrySelect(props) {
    const {
        // redux
        countries,
        publicCountries,
        // parent
        isPublic,
        hasValue, // whether the select box has a value/option selected;
        // if there is, display the clear select box (allowClear) button
        ...restProps
    } = props;

    const countriesList = isPublic ? publicCountries : countries;

    return (
        <Select
            style={{width: "100%"}}
            allowClear={hasValue}
            dropdownMatchSelectWidth={false}
            showSearch
            optionFilterProp="children"
            {...restProps}
        >
            { countriesList.map(item => <Option value={item.a2_code} key={item.a2_code}>{item.name}</Option>)}
        </Select>
    );
}
export default connect(state => ({
    countries: state.List.countries,
    publicCountries: state.PublicList.countries,
}), {})(withI18n()(CountrySelect));
